module.exports = __webpack_public_path__ + "img/font-bg.f595904c.png";